export interface PatternAreaType {
    maxVertices?: number | null;
    templateImage?: string | null;
    patternCoordinateMode?: 'gps' | 'normalized' | null;
}

// Keep aligned with the backend patternCoordinateService.
export const supportsNormalizedTemplate = (type?: PatternAreaType | null): boolean => (
    Boolean(type?.templateImage) && Number(type?.maxVertices) === 4 && type?.patternCoordinateMode !== 'gps'
);
